import { useState } from 'react';
import { Check, Copy } from 'lucide-react';

/** Small copy-to-clipboard button for reward coupon codes -- no shared
 * clipboard hook exists elsewhere in this codebase yet (the one other call
 * site, `features/admin/orders/order-detail-page.tsx`, does a bare
 * fire-and-forget `navigator.clipboard.writeText`), so this owns its own
 * "Copied" feedback state locally rather than introducing a new shared
 * utility for a single feature. */
export function CopyCodeButton({ value, label = 'Copy code' }: { value: string; label?: string }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    void navigator.clipboard.writeText(value).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      className="focus-visible:ring-brand inline-flex items-center gap-1.5 rounded-full border border-gray-200 bg-white px-3 py-1.5 text-xs font-semibold text-gray-700 hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2"
    >
      {copied ? (
        <>
          <Check className="h-3.5 w-3.5 text-green-600" aria-hidden="true" />
          Copied
        </>
      ) : (
        <>
          <Copy className="h-3.5 w-3.5" aria-hidden="true" />
          {label}
        </>
      )}
      <span className="sr-only" role="status">
        {copied ? `${value} copied to clipboard` : ''}
      </span>
    </button>
  );
}
